export default __webpack_public_path__ + "static/logo-modal-f5c33e6d4b1a81645c242c27c0a764b9.png";